import { zuiKey, ZuiExtensionObject } from '../../../z'

export type JsonSchema7AnyType = {
  [zuiKey]?: ZuiExtensionObject
}

export function parseAnyDef(): JsonSchema7AnyType {
  return {}
}
